import { LogsBase } from "areas/configuration/components/Diagnostics/Logs/LogsBase";

export class AutoDeployLogs extends LogsBase {
    constructor(props: any) {
        super("ProcessAutoDeployments", "Auto Deploy Logs", props);
    }
}

export default AutoDeployLogs;